import { TranslationService } from "@/core/services/TranslationService";
import moment from "moment";
import { endOfYear, startOfYear } from "date-fns";
export function setDateRangeShortcuts() {
  return [
    {
      label: TranslationService.translate("dateRange.today"),
      range: [moment(), moment()],
    },
    {
      label: TranslationService.translate("dateRange.yesterday"),
      range: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    },
    {
      label: TranslationService.translate("dateRange.lastSevenDays"),
      range: [moment().subtract(6, "days"), moment()],
    },
    {
      label: TranslationService.translate("dateRange.lastThirtyDays"),
      range: [moment().subtract(29, "days"), moment()],
    },
    {
      label: TranslationService.translate("dateRange.thisMonth"),
      range: [moment().startOf("month"), moment()],
    },
    {
      label: TranslationService.translate("dateRange.lastMonth"),
      range: [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: TranslationService.translate("dateRange.thisYear"),
      range: [startOfYear(new Date()), moment()],
    },
  ];
}
